import { render, staticRenderFns } from "./Flights.vue?vue&type=template&id=0db09412"
import script from "./Flights.vue?vue&type=script&lang=js"
export * from "./Flights.vue?vue&type=script&lang=js"
import style0 from "./Flights.vue?vue&type=style&index=0&id=0db09412&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports